export const brands = [
    "BilT",
    "Breedlove",
    "Charvel",
    "Cordoba",
    "D'Angelico",
    "Danelectro",
    "Epiphone",
    "ESP",
    "Fender",
    "Gibson",
    "Gretsch",
    "Ibanez",
    "Jackson",
    "Kramer",
    "Luna",
    "Martin",
    "Ovation",
    "PRS",
    "Rickenbacker",
    "Schecter",
    "Seagull",
    "Sire",
    "Squier",
    "Sterling",
    "Takamine",
    "Taylor",
    "Yamaha",
]

export const types = [
    "Acoustic",
    "Bass",
    "Electric"
]

export const sellers = [
    "Chicago Music Exchange",
    "Guitar Center",
    "Sweetwater",
]